import React, { useState, useEffect } from 'react';
// import MarketPanel from './components/MarketPanel';
// import MarketPanelFIIDII from './components/MarketPanelFIIDII';
// import MarketPanelAllIndex from './components/MarketPanelAllIndex';
// import MarketPanelGlobalData from './components/MarketPanelGlobalData';
// import MarketPanelBan from './components/MarketPanelBan';
import MarketPanelAsian from './components/MarketPanelAsian';
import MarketPanelIndian from './components/MarketPanelIndian';
import MarketPanelEuropean from './components/MarketPanelEuropean';
import MarketPanelUS from './components/MarketPanelUS';
import MarketPanelSummary from './components/MarketPanelSummary';
import MarketPanelStocksBreadth from './components/MarketPanelStocksBreadth';
import MarketPanelSectorBreadth from './components/MarketPanelSectorBreadth';
import MarketPanelAdvanceDecline from './components/MarketPanelAdvanceDecline';
import MarketPanelGainers from './components/MarketPanelGainers';
import MarketPanelLosers from './components/MarketPanelLosers';
import MarketPanelSectorWatch from './components/MarketPanelSectorWatch';
import MarketPanelKeySectorTrends from './components/MarketPanelKeySectorTrends';
import MarketPanelSectorRotation from './components/MarketPanelSectorRotation';
import MarketPanelSectorNews from './components/MarketPanelSectorNews';
import MarketPanelTrendingNow from './components/MarketPanelTrendingNow';
import MarketPanelPreMarketNews from './components/MarketPanelPreMarketNews';
import MarketPanelStocksToWatch from './components/MarketPanelStocksToWatch';
import MarketPanelSectorwiseData from './components/MarketPanelSectorwiseData';
import MarketPanel52WeekHighLow from './components/MarketPanel52WeekHighLow';
import MarketPanelPriceMovers from './components/MarketPanelPriceMovers';
import MarketPanelVolumeShockers from './components/MarketPanelVolumeShockers';
import MarketPanelMostVisited from './components/MarketPanelMostVisited';
import MarketPanelAllTimeHigh from './components/MarketPanelAllTimeHigh';
import MarketPanelIntradayMomentum from './components/MarketPanelIntradayMomentum';
import MarketPanelIntradayTrading from './components/MarketPanelIntradayTrading';
import MarketPanelVolatilityAlerts from './components/MarketPanelVolatilityAlerts';
import MarketPanelOptionsTrading from './components/MarketPanelOptionsTrading';
import MarketPanelSectorwiseSentiments from './components/MarketPanelSectorwiseSentiments';
import MarketPanelIPOInsights from './components/MarketPanelIPOInsights';
import MarketPanelUpcomingIPO from './components/MarketPanelUpcomingIPO';
import MarketPanelOngoingIPO from './components/MarketPanelOngoingIPO';
import MarketPanelIndexPerformance from './components/MarketPanelIndexPerformance';
import MarketPanelGainersNew from './components/MarketPanelGainersNew';
import MarketPanelLosersNew from './components/MarketPanelLosersNew';
import MarketPanelPutCallRatio from './components/MarketPanelPutCallRatio';
import MarketPanelNiftyOptions from './components/MarketPanelNiftyOptions';
import MarketPanelTrendingNowNew from './components/MarketPanelTrendingNowNew';
import MarketPanelSectorPerformance from './components/MarketPanelSectorPerformance';
import marketService from '../../services/marketService';

const Markets = () => {
  const [marketData, setMarketData] = useState({
    asianMarket: [],
    indianMarket: [],
    europeanMarket: [],
    usMarket: [],
    summary: {},
    stocksMarketBreadth: {},
    sectorsMarketBreadth: {},
    advanceDeclineTrends: [],
    gainers: [],
    losers: [],
    sectorToWatch: [],
    keySectorTrends: [],
    sectorRotation: [],
    sectorNews: [],
    trendingNow: [],
    preMarketNews: [],
    stocksToWatch: [],
    sectorwiseData: [],
    week52HighLow: [],
    priceMovers: [],
    volumeShockers: [],
    mostVisited: [],
    allTimeHigh: [],
    intradayMomentum: [],
    intradayTrading: [],
    volatilityAlerts: [],
    optionsTrading: [],
    sectorwiseSentiments: [],
    ipoInsights: [],
    upcomingIPO: [],
    ongoingIPO: [],
    indexPerformance: [],
    gainersNew: [],
    losersNew: [],
    putCallRatio: [],
    niftyOptions: [],
    trendingNowNew: [],
    sectorPerformance: []
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        setLoading(true);
        setError(null);
        const today = new Date();
        const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
        
        console.log('Fetching data for date:', formattedDate);

        const [
          stockMoverRes,
          advanceDeclineRes,
          sectorInsightsRes,
          stockInsightsRes,
          sectorwiseDataRes,
          priceVolumeRes,
          intradayRes,
          optionsRes,
          ipoRes,
          indicesRes,
          trendingRes,
          sectorPerfRes
        ] = await Promise.all([
          marketService.fetchStockMover(formattedDate),
          marketService.fetchAdvanceDeclineTrends(formattedDate),
          marketService.fetchSectorInsights(formattedDate),
          marketService.fetchStockInsights(formattedDate),
          marketService.fetchSectorwiseData(formattedDate),
          marketService.fetchPriceVolumeMovers(formattedDate),
          marketService.fetchIntradayAnalysis(formattedDate),
          marketService.fetchOptionsTrading(formattedDate),
          marketService.fetchIPOInsights(formattedDate),
          marketService.fetchIndicesMovers(formattedDate),
          marketService.fetchTrendingStocks(formattedDate),
          marketService.fetchSectorPerformance(formattedDate)
        ]);

        // Check if any response has an error
        const responses = [
          { name: 'stock-mover', response: stockMoverRes },
          { name: 'advance-decline', response: advanceDeclineRes },
          { name: 'sector-insights', response: sectorInsightsRes },
          { name: 'stock-insights', response: stockInsightsRes },
          { name: 'sectorwise-data', response: sectorwiseDataRes },
          { name: 'price-volume', response: priceVolumeRes },
          { name: 'intraday', response: intradayRes },
          { name: 'options', response: optionsRes },
          { name: 'ipo', response: ipoRes },
          { name: 'indices', response: indicesRes },
          { name: 'trending', response: trendingRes },
          { name: 'sector-performance', response: sectorPerfRes }
        ];

        for (const { name, response } of responses) {
          if (!response.success) {
            console.error(`Error in ${name} response:`, response.error);
          }
        }

        setMarketData(prevData => ({
          ...prevData,
          streetStatus: stockMoverRes.success ? stockMoverRes.data : [],
          advanceDeclineTrends: advanceDeclineRes.success ? advanceDeclineRes.data : [],
          sectorToWatch: sectorInsightsRes.success ? sectorInsightsRes.data : [],
          keySectorTrends: stockInsightsRes.success ? stockInsightsRes.data : [],
          sectorwiseData: sectorwiseDataRes.success ? sectorwiseDataRes.data : [],
          priceMovers: priceVolumeRes.success ? priceVolumeRes.data : [],
          intradayMomentum: intradayRes.success ? intradayRes.data : [],
          optionsTrading: optionsRes.success ? optionsRes.data : [],
          ipoInsights: ipoRes.success ? ipoRes.data : [],
          indexPerformance: indicesRes.success ? indicesRes.data : [],
          trendingNow: trendingRes.success ? trendingRes.data : [],
          sectorPerformance: sectorPerfRes.success ? sectorPerfRes.data : []
        }));

      } catch (error) {
        console.error('Error in fetchMarketData:', error);
        setError('Failed to fetch market data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMarketData();
    const interval = setInterval(fetchMarketData, 30000); // Refresh every 30 seconds

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div className="loading">Loading market data...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div>
        <div className="row pb-2">
          <div className="col-md-6">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/">
                  <i className="ti ti-home"></i> Home
                </a>
              </li>
              <li className="breadcrumb-item active">Markets</li>
            </ul>
          </div>
        </div>

        <div className="m-15">
          {/* Asian Market */}
          <MarketPanelAsian data={marketData.asianMarket} />

          {/* Indian Market */}
          <MarketPanelIndian data={marketData.indianMarket} />

          {/* European Market */}
          <MarketPanelEuropean data={marketData.europeanMarket} />

          {/* US Market */}
          <MarketPanelUS data={marketData.usMarket} />

          {/* Summary */}
          <MarketPanelSummary data={marketData.summary} />

          {/* Stocks Market Breadth */}
          <MarketPanelStocksBreadth data={marketData.stocksMarketBreadth} />

          {/* Sector Market Breadth */}
          <MarketPanelSectorBreadth data={marketData.sectorsMarketBreadth} />

          {/* Advance Decline Trends */}
          <MarketPanelAdvanceDecline data={marketData.advanceDeclineTrends} />

          {/* Gainers */}
          <MarketPanelGainers data={marketData.gainers} />

          {/* Losers */}
          <MarketPanelLosers data={marketData.losers} />

          {/* Sector to Watch */}
          <MarketPanelSectorWatch data={marketData.sectorToWatch} />

          {/* Key Sector Trends */}
          <MarketPanelKeySectorTrends data={marketData.keySectorTrends} />

          {/* Sector Rotation Analysis */}
          <MarketPanelSectorRotation data={marketData.sectorRotation} />

          {/* Sector News */}
          <MarketPanelSectorNews data={marketData.sectorNews} />

          {/* Trending Now */}
          <MarketPanelTrendingNow data={marketData.trendingNow} />

          {/* Pre Market News */}
          <MarketPanelPreMarketNews data={marketData.preMarketNews} />

          {/* Stocks to Watch */}
          <MarketPanelStocksToWatch data={marketData.stocksToWatch} />

          {/* Sectorwise Data */}
          <MarketPanelSectorwiseData data={marketData.sectorwiseData} />

          {/* 52 Week High Low */}
          <MarketPanel52WeekHighLow data={marketData.week52HighLow} />

          {/* Price Movers */}
          <MarketPanelPriceMovers data={marketData.priceMovers} />

          {/* Volume Shockers */}
          <MarketPanelVolumeShockers data={marketData.volumeShockers} />

          {/* Most Visited */}
          <MarketPanelMostVisited data={marketData.mostVisited} />

          {/* All Time High */}
          <MarketPanelAllTimeHigh data={marketData.allTimeHigh} />

          {/* Intraday Momentum Scanner */}
          <MarketPanelIntradayMomentum data={marketData.intradayMomentum} />

          {/* Intraday Trading Opportunities */}
          <MarketPanelIntradayTrading data={marketData.intradayTrading} />

          {/* Volatility Alerts */}
          <MarketPanelVolatilityAlerts data={marketData.volatilityAlerts} />

          {/* Options Trading Ideas */}
          <MarketPanelOptionsTrading data={marketData.optionsTrading} />

          {/* Sectorwise Market Sentiments */}
          <MarketPanelSectorwiseSentiments data={marketData.sectorwiseSentiments} />

          {/* IPO Insights */}
          <MarketPanelIPOInsights data={marketData.ipoInsights} />

          {/* Upcoming IPO */}
          <MarketPanelUpcomingIPO data={marketData.upcomingIPO} />

          {/* Ongoing IPO */}
          <MarketPanelOngoingIPO data={marketData.ongoingIPO} />

          {/* Index Performance */}
          <MarketPanelIndexPerformance data={marketData.indexPerformance} />

          {/* New Gainers */}
          <MarketPanelGainersNew data={marketData.gainersNew} />

          {/* New Losers */}
          <MarketPanelLosersNew data={marketData.losersNew} />

          {/* Put Call Ratio */}
          <MarketPanelPutCallRatio data={marketData.putCallRatio} />

          {/* Nifty Call Put Options */}
          <MarketPanelNiftyOptions data={marketData.niftyOptions} />

          {/* New Trending Now */}
          <MarketPanelTrendingNowNew data={marketData.trendingNowNew} />

          {/* Sector Performance */}
          <MarketPanelSectorPerformance data={marketData.sectorPerformance} />
        </div>
      </div>
    </div>
  );
};

export default Markets;